import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from "rxjs/Observable";

import 'rxjs/add/operator/map';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';

import * as globalConst from './../../../../constants';

@Injectable()
export class CollectStatusEditService {

	private apiUrl = globalConst.baseAPI;

	constructor(private http: Http) { }

	loadCollectStatus(token, ID) {

		return this.http
		.get(this.apiUrl + "collectstatus/v1/get/" + ID, JSON.parse(localStorage.getItem('yara.connectionHeader')))
		.map((res: Response) => res.json())
		.catch(e => {
			if (e.status === 401) {
				return Observable.throw('Unauthorized');
			}
		});
	}

	editCollectStatus(token, collectStatus: any) {

		return this.http
		.put(this.apiUrl + "collectstatus/v1/update", collectStatus, JSON.parse(localStorage.getItem('yara.connectionHeader')))
		.map((res: Response) => res.json())
		.catch(e => {
			if (e.status === 401) {
				return Observable.throw('Unauthorized');
			}
		});
	}

}



// WEBPACK FOOTER //
// ./src/app/collect-status/service/collect-status-edit/collect-status-edit.service.ts